import { DialogClassKey } from '@material-ui/core/Dialog'
import { StyleRules } from '@material-ui/core/styles/withStyles'

export const MuiDialog: Partial<StyleRules<DialogClassKey, {}>> = {
    root: {
        margin: '0px'
    }
}
